import React from 'react';
import { IonIcon } from '@ionic/react';
import { logOutOutline } from 'ionicons/icons';
import ProPageModal from '../bottom-sheet/ProPageModal';

export interface ProConfirmSheetProps {
  isOpen: boolean;
  onDismiss: () => void;
  title: string;
  body: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  variant?: 'default' | 'danger';
  confirmIcon?: string;
}

/**
 * Confirm/cancel bottom sheet built on ProPageModal.
 */
const ProConfirmSheet: React.FC<ProConfirmSheetProps> = ({
  isOpen,
  onDismiss,
  title,
  body,
  confirmLabel,
  cancelLabel,
  onConfirm,
  variant = 'default',
  confirmIcon,
}) => {
  const handleConfirm = () => {
    onConfirm();
  };

  const confirmClasses =
    variant === 'danger'
      ? 'bg-red-600 text-white active:bg-red-700'
      : 'bg-primary-700 text-white active:bg-primary-800 dark:bg-primary-600';

  return (
    <ProPageModal isOpen={isOpen} onDismiss={onDismiss} title={title}>
      <div className="px-4 py-5 space-y-4">
        <p className="text-sm text-text-secondary dark:text-text-dark-secondary leading-relaxed">
          {body}
        </p>
        <div className="space-y-2">
          <button
            type="button"
            onClick={handleConfirm}
            className={`w-full flex items-center justify-center gap-2 px-4 py-3 rounded-xl font-semibold text-sm transition-colors ${confirmClasses}`}
          >
            {confirmIcon && <IonIcon icon={confirmIcon} className="text-lg" />}
            {!confirmIcon && variant === 'danger' && (
              <IonIcon icon={logOutOutline} className="text-lg" />
            )}
            {confirmLabel}
          </button>
          <button
            type="button"
            onClick={onDismiss}
            className="w-full flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-transparent text-text-secondary dark:text-text-dark-secondary font-semibold text-sm transition-colors active:bg-black/5 dark:active:bg-white/5"
          >
            {cancelLabel}
          </button>
        </div>
      </div>
    </ProPageModal>
  );
};

export default ProConfirmSheet;
